function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "clock");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Artboard-Copy-3",
  transform: "translate(-78.000000, -133.000000)",
  fill: "currentColor",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "clock",
  transform: "translate(78.000000, 133.000000)"
}, React.createElement("path", {
  d: "M8.99166667,0.666666667 C4.39166667,0.666666667 0.666666667,4.4 0.666666667,9 C0.666666667,13.6 4.39166667,17.3333333 8.99166667,17.3333333 C13.6,17.3333333 17.3333333,13.6 17.3333333,9 C17.3333333,4.4 13.6,0.666666667 8.99166667,0.666666667 Z M9,15.6666667 C5.31666667,15.6666667 2.33333333,12.6833333 2.33333333,9 C2.33333333,5.31666667 5.31666667,2.33333333 9,2.33333333 C12.6833333,2.33333333 15.6666667,5.31666667 15.6666667,9 C15.6666667,12.6833333 12.6833333,15.6666667 9,15.6666667 Z",
  id: "Shape"
}), React.createElement("polygon", {
  id: "Path",
  points: "9.41666667 4.83333333 8.16666667 4.83333333 8.16666667 9.83333333 12.5416667 12.4583333 13.1666667 11.4333333 9.41666667 9.20833333"
}))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.4d9f8252.svg";
export { ForwardRef as ReactComponent };